import { useState } from 'react';

import PropTypes from 'prop-types';
import { HiUsers } from 'react-icons/hi2';

import Button from '#globalComponents/Button/Button';
import FormField from '#globalComponents/Forms/FormField';
import TextInput from '#globalComponents/Forms/TextInput';
import Modal from '#globalComponents/Overlay/Modal';
import Panel from '#globalComponents/Overlay/Panel';

import { useCreateContactList } from '../../models/mutations';

const CreateContactListModal = ({ isOpen, onClose }) => {
	const [name, setName] = useState('');
	const createMutation = useCreateContactList();

	const handleClose = () => {
		setName('');
		onClose();
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		const trimmed = name.trim();
		if (!trimmed) return;
		try {
			await createMutation.mutateAsync({ name: trimmed });
			handleClose();
		} catch {
			// The global MutationCache shows the toast; keep the dialog open for a retry.
		}
	};

	return (
		<Modal isOpen={isOpen} onClose={handleClose} size="s" as="form" onSubmit={handleSubmit}>
			<Panel.Header icon={HiUsers} onClose={handleClose}>
				Neue Kontaktliste erstellen
			</Panel.Header>
			<Panel.Body>
				<FormField label="Name" htmlFor="contact-list-name">
					<TextInput
						id="contact-list-name"
						value={name}
						onChange={(e) => setName(e.target.value)}
						placeholder="Name der neuen Liste ..."
						autoFocus
						maxLength={100}
					/>
				</FormField>
			</Panel.Body>
			<Panel.Footer className="justify-end">
				<Button variant="outline" size="sm" onClick={handleClose}>
					Abbrechen
				</Button>
				<Button type="submit" size="sm" disabled={!name.trim()} loading={createMutation.isPending}>
					Erstellen
				</Button>
			</Panel.Footer>
		</Modal>
	);
};

CreateContactListModal.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
};

export default CreateContactListModal;
